import React from 'react';
import { OfferSelector } from './OfferSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function FinalOffer() {
  return <section className="py-12 md:py-24 bg-brand-navy text-white relative overflow-hidden" data-id="element-77">
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-78"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-79">
        <div className="text-center max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-80">
          <h2 className="text-xs md:text-sm font-bold text-brand-gold uppercase tracking-widest mb-2 md:mb-3" data-id="element-81">
            Última oportunidad
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold mb-2 md:mb-4" data-id="element-82">
            Empezá a implementarlo esta semana
          </h3>
          <p className="text-sm md:text-lg text-slate-300" data-id="element-83">
            Sin improvisar más entre consultas. Elegí tu sistema abajo.
          </p>
        </div>

        <UrgencyBanner data-id="element-84" />

        <div className="bg-white/95 rounded-3xl p-5 md:p-8 shadow-2xl" data-id="element-85">
          <OfferSelector idPrefix="final" data-id="element-86" />
        </div>
      </div>
    </section>;
}